export const FIND_CARE_PROVIDER_SUCCESS = 'FIND_CARE_PROVIDER_SUCCESS';

export const findCareProviderSuccess = careProvider => ({
    type: FIND_CARE_PROVIDER_SUCCESS,
    payload: { careProvider },
});
